import { SlotReelSymbol } from "../../../../constants/enum/slot";
import { SlotPayouts } from "../../../../constants/slot";
import { SlotPayout } from "../../../../types/SlotPayout";
import { shuffleArray } from "./reel";

export const generateRandomNonce = () => {
  return Math.floor(Math.random() * 100000);
};

export const getPayoutSymbol = (nonce: number) => {
  let maxPayout = SlotPayouts[0];
  for (const payout of SlotPayouts) {
    if (nonce >= payout.from && nonce <= payout.to) {
      return payout;
    }
    if (payout.to > maxPayout.to) {
      maxPayout = payout;
    }
  }
  return maxPayout;
};

export const generateSpinResult = (slotPayout: SlotPayout) => {
  if (slotPayout.symbolCount === 0) {
    const symbols = SlotPayouts.slice(1).map((payout) => payout.symbol);
    const result: SlotReelSymbol[] = [];
    while (result.length < 3) {
      const randomSymbol = symbols[Math.floor(Math.random() * symbols.length)];
      if (!result.includes(randomSymbol)) {
        result.push(randomSymbol);
      }
    }
    return shuffleArray(result);
  } else if (slotPayout.symbolCount === 2) {
    const symbols = SlotPayouts.slice(1).map((payout) => payout.symbol);
    let randomSymbol;
    do {
      randomSymbol = symbols[Math.floor(Math.random() * symbols.length)];
    } while (randomSymbol === slotPayout.symbol);

    const result = [slotPayout.symbol, slotPayout.symbol, randomSymbol];

    return shuffleArray(result);
  } else if (slotPayout.symbolCount === 3) {
    return [slotPayout.symbol, slotPayout.symbol, slotPayout.symbol];
  }

  return [slotPayout.symbol, slotPayout.symbol, slotPayout.symbol];
};
